var site = site || {};
site.optin = site.optin || {};
site.optin.ui = site.optin.ui || {};

site.optin.optInInit = function () {
    site.optin.ui = {
        user: generic.user.getUser(),
        userEmailOption: (!$.isEmptyObject(site.optin.ui.user) ? site.optin.ui.user.pc_email_optin : 0),
        isEmailOptIn: false,
        optin_key: '',
        overlayOpened: 0
    };
};

jQuery(document).ready(function () {
  site.optin.optInInit();
});

site.optin.initOverlay = function () {
    if (site.optin.ui.overlayOpened) {
        return;
    } else {
        site.optin.ui.overlayOpened++;
    }
    if ($.cookie("OPTIN_SEEN") == null) {
        site.optin.launchOptinOverlay();
    }

};

// Launch email optin overlay
site.optin.launchOptinOverlay = function () {
    $.cookie("OPTIN_SEEN", 1, 31556926);
    generic.template.get({
        path: '/templates/optin_overlay.tmpl',
        object: {
            optin_key: site.optin.ui.optin_key
        },
        callback: function (html) {
            generic.overlay.launch({
                content: html,
                cssStyle: {
                    width: '661px',
                    height: 'auto',
                    border: 'none',
                    padding: '0px',
                    overflow: 'hidden'
                }
            });

            // listen for "submit" event
            var optinForm = $('#optin_overlay-_-email_signup');
            if (!optinForm) {
                return;
            }
            optinForm.on('submit',function (submitEvt) {
                submitEvt.preventDefault();
                //call submit handler
                submitClickHandler(optinForm);
            }); // end optinForm.observe


            var submitClickHandler = function (optinForm) {
                var paramObj = {};
                $.each(optinForm.serializeArray(), function (i, obj) {
                    paramObj[obj.name] = obj.value
                });
                paramObj._SUBMIT = "optin_overlay-_-email_signup";
                generic.jsonrpc.fetch({
                    method: 'rpc.form',
                    params: [paramObj],
                    onSuccess: function (jsonRpcResponse) {
                        $('.optin_content_container').hide();
                        $('.optin_success').show();
                        var reset = function () {
                            generic.overlay.hide();
                        };
                        this.timeout = setTimeout(reset.bind(this), 5000);
                    },
                    onFailure: function (jsonRpcResponse) {
                        var errorObjectsArray = jsonRpcResponse.getMessages();
                        var errListNode = optinForm.find("ul.error_messages");
                        generic.showErrors(errorObjectsArray, errListNode, optinForm);
                    }
                }); // end generic.jsonrpc.fetch
            };
        }
    });
};
